import { NSASectionViewTabPageTabPageTab } from "namirasoft-account-react";
import { ContentTemplateRow } from "namirasoft-content-template";
import { BaseMetaColumn, BaseMetaTable } from "namirasoft-core";
import { BaseVariableSchema } from "namirasoft-schema";
import { BaseColumnFormatter, BooleanFormatter, EnumFormatter, NSNoData, NSTable, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";

interface ParameterRow
{
	index: number;
	name: string;
	type: string;
	required: boolean;
	default_value: string;
	example: string;
}

interface ContentTemplateParameterListProps
{
	content_template: ContentTemplateRow;
}

export function ContentTemplateParameterList(props: ContentTemplateParameterListProps)
{
	let parameters = props.content_template.parameters?.filter(p => p) as BaseVariableSchema[] ?? [];
	if (parameters.length === 0)
		return <NSNoData lable="This content template has no parameters." />;

	let rows: ParameterRow[] = parameters.map((p, index) => ({
		index,
		name: p.name,
		type: p.type?.type ?? "",
		required: p.type?.required ?? false,
		default_value: p.defaultValue ?? "",
		example: p.type?.example ?? ""
	}));

	let table = new BaseMetaTable(null, "parameter", "Parameter");
	let columns = [
		BaseColumnFormatter.getColumn(new BaseMetaColumn(table, "name", "Name", "String", true), new StringFormatter(StringFormatterSizeType.FullName)),
		BaseColumnFormatter.getColumn(new BaseMetaColumn(table, "type", "Type", "Enum", true), new EnumFormatter()),
		BaseColumnFormatter.getColumn(new BaseMetaColumn(table, "required", "Required", "Boolean", true), new BooleanFormatter("Yes", "No")),
		BaseColumnFormatter.getColumn(new BaseMetaColumn(table, "default_value", "Default Value", "String", false), new StringFormatter(StringFormatterSizeType.Description)),
		BaseColumnFormatter.getColumn(new BaseMetaColumn(table, "example", "Example", "String", false), new StringFormatter(StringFormatterSizeType.Description))
	];

	return (
		<NSTable<ParameterRow>
			// remount when switching between content templates so rows are reloaded
			key={props.content_template.id}
			name={`content-template-parameters-${props.content_template.id}`}
			checkbox={false}
			columns={columns}
			getRows={async () => ({ rows, count: rows.length })}
			getRowKey={e => e.value.index.toString()}
			ui={{ pagination: false }}
			style={{ height: "auto" }}
		/>
	);
}

export function getContentTemplateParameterTab(): NSASectionViewTabPageTabPageTab<ContentTemplateRow>
{
	return {
		title: "Parameters",
		clicked: false,
		isVisible: (model) => !!model.row,
		getContent: (model) => model.row ? <ContentTemplateParameterList content_template={model.row} /> : null
	};
}